<template>
  <div class="tasks_container top-left w50 left margin margin_r_hf margin_l_c">
    <!--     <deposits-charts></deposits-charts>-->
    <!--        <announcements-charts></announcements-charts>-->
    <tasks-charts
        v-if="mainView === 'all_tasks'"
        :isTranslate="isTranslate">

    </tasks-charts>
  </div>
</template>

<script>
import apiClientCreator from "../../../../../helpers/api/request";
import Chart from "chart.js";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment/moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CahartAnnot from "chartjs-plugin-annotation";
import TasksCharts from "../components/TasksCharts.component";

export default {
  name: "Graph.container",
  props: {
    isTranslate: {
      type: Boolean
    }
  },
  components: {
    TasksCharts
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("clients", ["updateDepCharts"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "updateDepCharts",
      "chartsMainView",
      "campChartData"
    ]),
    ...mapState("tasks", [
      "tasks",
      "activeTasks",
      "allActiveTasks",
      "getFetchTasks",
      "activeTasksCounter",
      "chartDataToTable",
      "taskDictionaries",
      "chartsViewBlocks"
    ])
  },
  data() {
    return {
      mainView: 'all_tasks',

      selectedUserGraphTab: "BROKERS",
      selectedGraphTab: "MONTH"
    };
  },
  mounted() {},

  watch: {
    chartsViewBlocks:function(){
      this.mainView = this.chartsViewBlocks[1]
    },
  },

  methods: {}
};
</script>
<style scoped>
.tasks_container {
  width: 44.8% !important;
}
.root {
  height: 180px;
}
.chart-root {
  display: flex;
}
.goal-root {
  float: right;
}
.tabs-area {
  //display: inline-flex;
  position: relative;
}
.nav {
  height: 25px;
  margin-bottom: 8px;
}
.nav-tabs a {
  height: 25px;
  padding: 5px;
}
.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 10pt;
  font-weight: bold;
  color: #1e88e5;
}
.main-chart {
  width: 620px;
  height: 150px;
  float: left;
  /* border: solid 1px #d6f4ff;*/
  padding: 5px;
  border-radius: 3px;
  position: relative;
}
.trans-chart {
  width: 200px;
  height: 150px;
  float: left;
  /* border: solid 1px #d6f4ff;*/
  padding: 5px;
  border-radius: 3px;
  margin-left: 3px;
}
.goal-chart {
  width: 94px;
  height: 150px;
  float: left;
  /* border: solid 1px #d6f4ff;*/
  padding: 5px;
  border-radius: 3px;
  margin-left: 3px;
}
.campaign-chart {
  width: 100%;
  height: 190px;
}
.main-chart-brokers {
  width: 830px;
  height: 140px;
}
.main-chart-today {
  width: 830px;
  height: 140px;
}
.main-chart-month-brokers {
  width: 930px;
  height: 140px;
}
.main-chart-month-countries {
  width: 700px;
  height: 140px;
}

.main-chart-month-tiers {
  width: 230px;
  height: 140px;
  position: absolute;
  right: 0;
  top: -5px;
}

.main-chart-month {
  width: 830px;
  height: 140px;
}

.goal-text {
  position: absolute;
  bottom: -5px;
  left: 33px;
}
.goal-ratio {
  position: absolute;
  top: -27px;
  left: 38px;
  font-size: 11px;
  font-weight: normal;
  color: #44a2d2;
  display: none;
}

.back-icon {
  cursor: pointer;
  font-size: 14pt;
  position: absolute;
  bottom: 5px;
  left: 5px;
}
.spinner-graphs {
  position: absolute;
  top: 50px;
  left: 430px;
}
.selected-user-name {
  position: absolute;
  right: 10px;
  bottom: 5px;
  font-weight: bold;
  font-family: Montserrat;
  font-size: 9pt;
}

/*.w50 {*/
/*  width: calc(50% - 0.2rem);*/
/*}*/
.left {
  float: left;
}
.margin {
  /*margin: 0.5rem;*/
}
.margin_r_hf {
  /*margin-right: 0.2rem;*/
}
.margin_l_c {
  margin-left: 0;
}
.styleCard {
  overflow: hidden;
  height: 200px;
  position: relative;
  font-family: Montserrat;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
        background: white;
      */
}
.style-nav.style2 li {
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 172px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.padding {
  padding: 1rem;
}
.sysChatActions {
  position: absolute;
  bottom: 35px;
  left: 60px;
  border-top: 1px solid #ebeff2;
}
.sysChatActions button:hover img {
  transform: translateX(-10px);
}
.sysChatActions button img {
  transition: transform 0.3s ease;
}
.sysChatActions button {
  width: 75px;
  background: none;
  border: 0;
  position: absolute;
  top: 0.1rem;
  right: 0;
  text-align: center;
  cursor: pointer;
  height: 37px;
}
.loader-pos {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: -30px;
  left: 0;
}
.winner-div {
  width: 100px;
  height: 120px;
  position: absolute;
  top: 0px;
  text-align: center;
}

.ind-body-first {
  background: rgba(0, 128, 0, 0.2);
  width: 100%;
  height: 100px;
}
.ind-body-last {
  background: rgba(255, 0, 0, 0.2);
  width: 100%;
  height: 100px;
}
.looser-div {
  width: 100px;
  height: 120px;
  position: absolute;
  top: 0px;
  text-align: center;
  right: 0;
}
</style>
